import Base64 from 'base-64'
import utf8 from 'utf8'

function shorten(str, n = 30) {
  if (str && str.length > n) {
    return str.substr(0, n - 1) + '…'
  }
  else {
    return str
  }
}

function inGroupsOf(perRow, array, dummy = undefined) {
  if (perRow < 1) {
    throw `perRow has to be greater than 0 (${perRow})`
  }

  let result = []
  let current = []
  for (const i of array) {
    if (current.length == perRow) {
      result.push(current)
      current = []
    }

    current.push(i)
  }
  if (current.length > 0) {
    if (dummy !== undefined) {
      while (current.length < perRow) {
        current.push(dummy)
      }
    }

    result.push(current)
  }

  return result
}

function groupBy(array, criteria) {
  const f = (
    typeof criteria == 'string' ?
    function(e) {return e[criteria]} :
    criteria
  )

  let result = {}

  for (const e of array) {
    const key = f(e)
    result[key] = result[key] || []
    result[key].push(e)
  }

  return result
}

function capitalize(string) {
  if (typeof string != 'string') {
    return string
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}

function compact(object, deep = false) {
  let result = {...object}
  for (const [k, v] of Object.entries(object)) {
    if (v === null || v === undefined)  {
      delete result[k]
    } else {
      if (deep && typeof v === 'object') {
        result[k] = compact(v)
      }
    }
  }
  return result
}

function toPage(value) {
  if (typeof value == 'string') {return parseInt(value, 10)}

  return 1
}

function toBase64(string) {
  if (typeof atob !== 'undefined') {
    return btoa(string)
  } else {
    return Buffer.from(string, 'utf-8').toString('base64')
  }
}

function fromBase64(string) {
  if (typeof btoa !== 'undefined') {
    return atob(string)
  } else {
    return Buffer.from(string, 'base64').toString('utf-8')
  }
}

class VwUnit {
  setup() {
    window.addEventListener('resize', this.recalculate)
    this.recalculate()
  }

  recalculate() {
    let vw = document.documentElement.clientWidth / 100;
    console.log(`detected usable page width of ${vw}px`)
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }
}

const fold = (str) => {
  if (str == undefined) {return str}

  return str.toString().trim().toLowerCase().
    replaceAll(/[äáàâå]/g, 'a').
    replaceAll(/[öóòôðø]/g, 'o').
    replaceAll(/[iíìî]/g, 'i').
    replaceAll(/[ëéèê]/g, 'e').
    replaceAll(/[üúùû]/g, 'u').
    replaceAll(/[ÿ]/g, 'y').
    replaceAll(/[ćč]/g, 'c').
    replaceAll(/[ł]/g, 'l').
    replaceAll(/[śš]/g, 's').
    replaceAll(/[ż]/g, 'z').
    replaceAll(/æ/g, 'ae').
    replaceAll(/ß/g, 'ss').
    replaceAll(/ł/g, 'l')

}

const regEscape = (str) => {
  return str.toString().
    replaceAll(/\./g, "\\.").
    replaceAll(/\$/g, "\\$").
    replaceAll(/\^/g, "\\^").
    replaceAll(/\(/g, "\\(").
    replaceAll(/\)/g, "\\)")
}

const camelToSnakeCase = (str) => {
  if (typeof str != 'string') {
    return str
  }

  return str.replaceAll(/([A-Z])/g, (m) => '_' + m.toLowerCase(m))
}

const transformKeys = (obj, f) => {
  const result = {}
  for (const [k, v] of Object.entries(obj)) {
    result[f(k)] = v
  }
  return result
}

const allCss = () => {
  const selector = "link[rel='stylesheet'], style"
  const elements = [...document.querySelectorAll(selector)]
  const styles = []
  const promises = []

  const result = new Promise((resolve) => {
    for (let i = 0; i < elements.length; i++) {
      const e = elements[i]
      if (e.tagName == 'STYLE') {
        styles[i] = e.innerHTML
      } else {
        const url = e.getAttribute('href')
        const p = fetch(url).
          then(r => r.text()).
          then(data => styles[i] = data)
        promises.push(p)
      }
    }

    Promise.all(promises).then(() => {
      resolve(styles.join("\n"))
    })
  })

  return(result)
}

const printElement = (element, {css, title, print=true} = {}) => {
  const w = window.open('', 'PRINT', 'height=800,width=1024')
  const html = `
    <html>
      <head>
        <meta charset="utf-8" />
        <title>${title || document.title}</title>
        <style>${css}</style>
      </head>
      <body class="w-print">${element.innerHTML}</body>
    </html>
  `
  w.document.write(html)
  w.document.close()

  w.addEventListener('afterprint', (event) => {
    // we use a timeout here because firefox tries to close the window before
    // the print dialog is removed which fails to close the window
    w.setTimeout(() => w.close(), 1)
  })
  if (print) {w.print()}
}

const dataUri = (data, contentType = 'text/plain') => {
  const u = utf8.encode(data)
  const b64 = Base64.encode(u)
  return `data:${contentType};base64,${b64}`
}

const download = (data, {contentType='text/plain', filename='data.txt'}) => {
  const uri = dataUri(data, contentType)
  const a = document.createElement('a')
  a.download = filename
  a.setAttribute('href', uri)

  document.documentElement.append(a)
  a.click()
}

const sortBy = (array, f) => {
  return [...array].sort((a, b) => {
    const af = f(a)
    const bf = f(b)

    if (af > bf) return 1
    if (af < bf) return -1

    return 0
  })
}

function parents(element, selector) {
  if (element.matches(selector)) {
    return element
  }

  if (element.parentElement == null) {
    return null
  }

  return parents(element.parentElement, selector)
}

function fetchWorker(url) {
  return fetch(url).then(r => r.text()).then(src => {
    const blob = new Blob([src], {type: 'application/javascript'})
    const url = URL.createObjectURL(blob);
    return new Worker(url)
  })
}

function dashToCamel(str) {
  return str.replaceAll(/\-(.)/g, (m) => m[1].toUpperCase())
}

function range(limits) {
  const [from, to] = limits
  if (to < from) return []


  const result = new Array(to - from + 1)
  return Array.from(result, (e, i) => i + from)
}

function mapTo(value, fromRange, toRange=[0.0, 1.0]) {
  let result = value - fromRange[0]
  result /= fromRange[1] - fromRange[0]
  result *= toRange[1] - toRange[0]
  return result + toRange[0]
}

function clamp(value, range=[0.0, 1.0]) {
  return Math.min(Math.max(value, range[0]), range[1])
}

function randomString(length, characters=null) {
  const pool = characters || [
    'abcdefghijklmnopqrstuvwxyz',
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    '0123456789'
  ].join('')

  let result = []
  for (let i = 0; i < length; i++) {
    const index = Math.floor(Math.random() * pool.length)
    result.push(pool[index])
  }
  return result.join('')
}

const delay = (f, ms) => {
  let timeout = null

  const future = (resolve, ...args) => {
    const result = f(...args)
    resolve(result)
  }

  const handler = (...args) => {
    if (timeout) {
      window.clearTimeout(timeout)
    }

    return new Promise((resolve, reject) => {
      timeout = window.setTimeout(future, ms, resolve, ...args)
    })
  }

  return handler
}

const highlight = (str, term) => {
  if (!str) return null
  if (!term) return str

  const folded = fold(str)
  const regex = new RegExp(fold(term), 'g')

  const matches = [...folded.matchAll(regex)].reverse()

  let result = `${str}`
  for (const m of matches) {
    const length = m[0].length
    const index =  m.index

    const prefix = result.slice(0, index)
    const highlight = result.slice(index, index + length)
    const suffix = result.slice(index + length)

    // console.log(str, term, prefix, highlight, suffix, index, length, m)
    
    result = `${prefix}<mark>${highlight}</mark>${suffix}`
  }

  return result
}

const wrapTextWith = (node, pattern, element='mark', attribs={}) => {
  if (node.nodeType == Node.TEXT_NODE) {
    // we use the reversed list of matches so that earlier matches don't
    // influence later ones
    const matches = [...node.nodeValue.matchAll(pattern)].reverse()

    for (const m of matches) {
      const subject = node.splitText(m.index)
      const right = subject.splitText(m[0].length)

      const e = document.createElement(element)
      for (const [k, v] of Object.entries(attribs)) e.setAttribute(k, v)
      subject.replaceWith(e)
      e.append(subject)
    }
  } else {
    // we generate a static list of nodes so that replacements aren't iterated
    // on
    const nodes = [...node.childNodes]

    for (const n of nodes) {
      wrapTextWith(n, pattern, element, attribs)
    }
  }
}

const createElement = (html) => {
  const builder = document.createElement('div')
  builder.innerHTML = html

  let elements = []

  for (const node of builder.childNodes) {
    if (node.nodeType == Node.ELEMENT_NODE) {
      elements.push(node)
    }
  }

  return elements.length > 1 ? elements : elements[0]
}

const nodesAreOverlappingY = (a, b) => {
  const scrollY = window.scrollY

  const aTop = a.getBoundingClientRect().top + scrollY
  const aBottom = aTop + a.offsetHeight
  const bTop = b.getBoundingClientRect().top + scrollY
  const bBottom = bTop + b.offsetHeight

  return aBottom >= bTop && aTop <= bBottom
}

const shuffle = (original) => {
  let array = original.slice()

  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

const removeContents = (element) => {
  let result = []

  const nodes = [...element.childNodes]
  for (const c of nodes) {
    result.push(c)
    c.remove()
  }

  return result
}

const replaceContents = (element, content) => {
  const old = removeContents(element)

  for (const c of content) {
    element.appendChild(c)
  }

  return old
}

const requestAnimationFrame = () => {
  return new Promise((resolve, reject) => {
    window.requestAnimationFrame(timestamp => {
      resolve()
    })
  })
}

const wait = (ms = 0) => {
  return new Promise((resolve, reject) => {
    window.setTimeout(resolve, ms)
  })
}

const unique = (array) => {
  const set = new Set(array)
  return [...set]
}

export {
  allCss,
  clamp,
  createElement,
  mapTo,
  dashToCamel,
  delay,
  shorten,
  inGroupsOf,
  capitalize,
  compact,
  fetchWorker,
  toBase64,
  fromBase64,
  highlight,
  VwUnit,
  fold,
  regEscape,
  removeContents,
  replaceContents,
  camelToSnakeCase,
  nodesAreOverlappingY,
  transformKeys,
  printElement,
  dataUri,
  download,
  shuffle,
  sortBy,
  parents,
  toPage,
  range,
  randomString,
  wrapTextWith,
  requestAnimationFrame,
  wait,
  unique,
}
